import { render } from "./BaseTool.vue?vue&type=template&id=5a686759&scoped=true"
import script from "./BaseTool.vue?vue&type=script&lang=js"
export * from "./BaseTool.vue?vue&type=script&lang=js"

import "./BaseTool.vue?vue&type=style&index=0&id=5a686759&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a686759"]])

export default __exports__